'use strict';
var parent = require('../../stable/instance/index-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/instance/index-of.js
// module id = 533
// module chunks = 13